
const SuccessContact = () => {


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      {/* Иконка галочки */}
      <img
        src="/done.svg" // замените на путь к вашей галочке
        alt="Done"
        className="w-40 h-40 mb-6"
      />

      {/* Текст "Done!" */}
      <h1 className="text-3xl font-bold text-pink-500 mb-3">Successfully!</h1>

      {/* Текст "Payment success" */}
      <p className="text-lg font-medium text-gray-800 mb-4">Thanks for your request. </p>

      {/* Подтекст */}
      <p className="text-lg font-medium text-center text-gray-800 mb-4">The Solvi team will contact you <br /> shortly. </p>

            <button
        className="w-[350px] max-w-md py-5 bg-pinkCustom text-white rounded-full hover:bg-pinkCustom transition"
      >
        Close
      </button>
    </div>
  );
};

export default SuccessContact;
